<template>
    <div class="idou">
        <h3>異動届</h3>
        <div class="col-item">
            <b v-if="idou?.todokede_kubun != OptionConst.TODOKEDE_KUBUN.HANNICHI_HOSEI" class="title">異動日</b>
            <b v-else class="title">半日補正日</b>
            <p>{{ idou?.idou_date }}</p>
        </div>
        <div class="col-item">
            <b class="title">就業場所</b>
            <p>{{ form.syuugyou_basyo_name }}</p>
        </div>
        <div class="col-item">
            <b class="title">届出区分</b>
            <p>{{ todokedeKubunOption.find(v => v.val == idou?.todokede_kubun)?.label }}</p>
        </div>
        <div class="col-item">
            <b class="title">{{ todokede1Label }}</b>
            <p class="pre">{{ idou?.todokede1_naiyou }}</p>
        </div>
        <div class="col-item" v-if="todokede2Label">
            <b class="title">{{ todokede2Label }}</b>
            <p class="pre">{{ idou?.todokede2_naiyou }}</p>
        </div>
        <div class="col-item">
            <b class="title">備考</b>
            <p class="pre">{{ form.notes ?? '無し' }}</p>
        </div>
    </div>
</template>

<script lang="ts">

import { defineComponent, ref, onMounted, computed } from 'vue';
import OptionConst from '@/const/Option';
import { Shinsei } from '@/types/Shinsei';
import { useAuthStore } from '@/store/auth';

export default defineComponent({
  props:{
    form: {
      type: Object as () => Shinsei,
      default: null
    },
  },
  setup(props) {

    let idou = props.form.idou;
    const todokede1Label = ref('届出内容');
    const todokede2Label = ref();
    const authStore = useAuthStore();
    const syozokuId = computed(() => {
      return authStore.user?.mst_syozoku_id
    })
    const todokedeKubunOption = computed(() => {
      if (syozokuId && syozokuId.value === OptionConst.SYOZOKU.PM) {
        return OptionConst.TODOKEDE_KUBUN_OPTION_PM;
      }
      else {
        return OptionConst.TODOKEDE_KUBUN_OPTION_PG;
      }
    })

    onMounted(() => {
      if(idou?.todokede_kubun == OptionConst.TODOKEDE_KUBUN.JUUSYO_CHANGE){
        todokede1Label.value = '郵便番号'
        todokede2Label.value = '住所'
      }
      if(idou?.todokede_kubun == OptionConst.TODOKEDE_KUBUN.KAISEI){
        todokede1Label.value = '(新)姓名'
        todokede2Label.value = '(新)姓名（カナ）'
      }
    })

    return {
      idou,
      todokede1Label,
      todokede2Label,
      'todokedeKubunOption': todokedeKubunOption,
      OptionConst,
    }
  },
  components: {

  }
})

</script>
<style lang="scss" scoped>
@import '@scss/components/shinsei-detail.scss';
</style>